<template>
  <div class="margin-top-10 h-100">
    <div class="text-left">
      <el-button @touchstart="() => openDialog('add',{})"  @click="() => openDialog('add',{})"
                 icon="el-icon-circle-plus-outline"
                 size="mini" type="primary">
        新增
      </el-button>
    </div>
    <el-row style="height: calc(100% - 80px)">
      <el-table
        :data="accessList"
        class="table no-row-border"
         size="mini"
         border
        style="width: 100%;max-height: 100%;margin-top: 10px;overflow-y: auto">
        <el-table-column type="expand"
                         width="30">
          <template slot-scope="scope">
            <el-table
              :data="scope.row.door"
               size="mini"
              class="table no-row-border"
              style="width: 800px;margin-left: 70px;"
             >
              <el-table-column
                align="center"
                label="门名称"
                width="200"
                prop="name">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.edit" size="mini" v-model="scope.row.name"></el-input>
                  <span v-else>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                width="200"
                label="所属区域"
                prop="area_name">
                <template slot-scope="scope">
                  <el-select
                    v-if="scope.row.edit"
                    v-model="scope.row.area"
                    placeholder="请选择部门"
                    size="mini"
                    style="width: 100%">
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <span v-else>{{ scope.row.area_name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button class="pointer"
                             v-if="scope.row.edit"
                             size="mini" type="primary"
                             @touchstart="saveDoor(scope.row)"
                             @click="saveDoor(scope.row)">
                    保存
                  </el-button>
                  <el-button class="pointer"
                             v-else
                             size="mini" type="primary"
                             @touchstart="editDoor(scope.row)"
                             @click="editDoor(scope.row)">
                    编辑
                  </el-button>
                  <el-button class="pointer margin-left-5"
                             size="mini" type="primary"
                             @touchstart="openDoor(scope.row,1)"
                             @click="openDoor(scope.row,1)">
                    开门
                  </el-button>
<!--                  <el-button class="pointer margin-left-5"-->
<!--                             size="mini" type="primary"-->
<!--                             @click="openDoor(scope.row,0)">-->
<!--                    关门-->
<!--                  </el-button>-->
<!--                  <el-button class="pointer margin-left-5"-->
<!--                             size="mini" type="primary"-->
<!--                             @click="openDoor(scope.row,2)">-->
<!--                    常开门-->
<!--                  </el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="序号"
          width="100"
          type="index">
        </el-table-column>
        <el-table-column
          align="center"
          label="设备ID"
          prop="id">
        </el-table-column>
        <el-table-column
          align="center"
          label="品牌名"
          prop="model_name">
        </el-table-column>
        <el-table-column
          align="center"
          label="控制器SN"
          prop="devSn">
        </el-table-column>
        <el-table-column
          align="center"
          label="IP地址"
          prop="ip">
        </el-table-column>
        <el-table-column
          align="center"
          label="子网掩码"
          prop="mask">
        </el-table-column>
        <el-table-column
          align="center"
          label="网关地址"
          prop="gateway">
        </el-table-column>
        <el-table-column
          align="center"
          label="控制器类型"
          prop="type">
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
              <span class="pointer text-blue" @touchstart="() => openDialog('edit',scope.row)" @click="() => openDialog('edit',scope.row)">
                <i class="el-icon-edit" style="margin-right: 5px"></i>编辑
              </span>
            <span class="pointer text-red margin-left-10" @touchstart="deleteControl(scope.row)" @click="deleteControl(scope.row)">
                <i class="el-icon-delete" style="margin-right: 5px"></i>删除
              </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>


    <dialog-component :width="width"
                      :closeClick="false"
                      :dialogVisible.sync="dialogVisible"
                      :pressClick="false"
                      :showClose="true"
                      @dialogClose="closeDialog"
                      :dialog-title="title">
      <div slot="content">
        <div style="height: 250px;margin: 30px;overflow-y: auto">
          <el-row v-if="operate === 'add' && selectAccess.length > 0">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">可选控制器：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-radio-group v-model="dialogData.devSn"
                              @change="selectDevSn"
                              size="mini">
                <el-radio :label="item.devSn" border
                          style="margin-right: 0"
                          v-for="item in selectAccess"
                          :key="item.id">{{ item.devSn }}
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">控制器SN：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.devSn"
                        class="input"
                        :disabled="operate === 'edit'"
                        placeholder="请输入控制器SN"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">IP地址：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.ip" placeholder="请输入IP地址"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">子网掩码：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.mask" placeholder="请输入子网掩码"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">网关地址：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.gateway" placeholder="请输入网关地址"></el-input>
            </el-col>
          </el-row>

          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">品牌：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">

              <!--              <el-input size="mini" v-model="dialogData.model" placeholder="请输入网关地址"></el-input>-->


              <el-select v-model="dialogData.model" placeholder="请选择品牌" size="mini" style="width: 100%">

                <el-option v-for="item in brandList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>


            </el-col>
          </el-row>

        </div>
      </div>
      <div slot="footer" style="text-align: center;margin-bottom: 30px">
        <el-button type="primary" plain size="mini" @touchstart="closeDialog" @click="closeDialog">取消</el-button>
        <el-button type="primary" size="mini" @touchstart="confirm" @click="confirm">确认</el-button>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import _ from "lodash";
import DialogComponent from "@/components/DialogComponent";

export default {
  name: "Control",
  props: ['accessList', 'selectAccess', 'areaList', 'brandList'],
  components: {DialogComponent},
  data() {
    return {
      dialogVisible: false,
      width: "40vw",
      title: "",
      operate: "",
      dialogData: {},
      // brandList: {}
    }
  },
  watch: {
    'dialogData.devSn': {
      handler(val) {
        const access = this.selectAccess.filter(item => item.devSn + '' === val + '')
        if (access.length > 0) {
          this.dialogData = _.cloneDeep(access[0])
        }
      }
    }
  },
  methods: {
    openDialog(operate, row) {
      this.operate = operate
      this.dialogData = _.cloneDeep(row)
      if (operate === 'add') {
        this.dialogData = {
          ip: "192.168.1.1",
          mask: '255.255.255.0',
          gateway: '0.0.0.0',
        }
      }
      if (operate === 'add') {
        this.title = '新增控制器'
      } else {
        this.title = '编辑控制器'
      }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false;
      this.dialogData = {}
    },
    selectDevSn() {
    },
    deleteControl(row) {
      this.$confirm('是否确认删除' + row.devSn, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$emit('sendWebsocket', 'delAccess', row)
          }
        }
      })
    },
    confirm() {
      if (this.dialogData.devSn === undefined || (this.dialogData.devSn + '').trim() === "") {
        this.$message.error("请输入控制码SN!")
        return false
      }
      if (this.dialogData.ip.trim() === "") {
        this.$message.error("请输入IP地址!")
        return false
      }
      if (this.dialogData.mask.trim() === "") {
        this.$message.error("请输入子网掩码!")
        return false
      }
      if (this.dialogData.gateway.trim() === "") {
        this.$message.error("请输入网关地址!")
        return false
      }
      this.dialogData.devSn = parseInt(this.dialogData.devSn)
      this.$emit('sendWebsocket', this.operate === 'add' ? 'addAccess' : 'alterAccess', this.dialogData)
    },
    editDoor(row) {
      this.$set(row, 'edit', true)
      this.$forceUpdate()
    },
    saveDoor(row) {
      if (row.name.trim() === "") {
        this.$message.error("门名称不能为空!")
        return false
      }
      this.$emit('sendWebsocket', 'alterDoor', row)
    },
    openDoor(row, switching) {
      // switchingDoor 控制门 switching 控制码,为空时默认为1(0=关门,1=开门,2=长开门)
      console.log(row);
      row.switching = switching;
      // this.$emit('sendWebsocket', 'openDoor', row)
      this.$emit('sendWebsocket', 'switchingDoor', row)
    }
  }
}
</script>

<style scoped>
::v-deep .el-table__expand-icon{
  color: #fff !important;
}
</style>
